/**
 * @module app.bdc.list.formOrderWebTillsCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {

    function FormOrderWebTillsCtrl($scope, $uibModalInstance, $log, webTillPackages, Notification) {
        var self = {};
        self.webTillPackages = webTillPackages;
        self.webTillPackage = {};

        /**
         * Set the web till package
         * @param checkedPackage
         */
        self.choosePackage = function choosePackage(checkedPackage) {
            for (var webTillPackage of self.webTillPackages) {
                webTillPackage.checked = false;
            }
            self.webTillPackage = checkedPackage;
            self.webTillPackage.checked = true;
        };

        /**
         * Close the modal
         */
        self.ok = function ok() {
            $uibModalInstance.close();
        };

        /**
         * Cancel the modal
         */
        self.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel');
        };

        return self;
    }

    FormOrderWebTillsCtrl.$inject = ['$scope', '$uibModalInstance', '$log', 'webTillPackages', 'Notification'];

    angular
        .module('app.bdc.list.formOrderWebTillsCtrl', ['ui.bootstrap.modal', 'ui-notification'])
        .controller('FormOrderWebTillsCtrl', FormOrderWebTillsCtrl);
});
